import * as types from '../types/productTypes';

const initialState = {
  products: [],
  product: null,
  stats: null,
  loading: false,
  error: null,
};

function productReducer(state = initialState, action) {
  switch (action.type) {
    case types.FETCH_PRODUCTS_REQUEST:
    case types.FETCH_PRODUCT_STATS_REQUEST:
    case types.FETCH_PRODUCT_BY_ID_REQUEST:
    case types.CREATE_PRODUCT_REQUEST:
    case types.UPDATE_PRODUCT_REQUEST:
    case types.DELETE_PRODUCT_REQUEST:
      return { ...state, loading: true, error: null };
    case types.FETCH_PRODUCTS_SUCCESS:
      return { ...state, loading: false, products: action.payload };
    case types.FETCH_PRODUCT_STATS_SUCCESS:
      return { ...state, loading: false, stats: action.payload };
    case types.FETCH_PRODUCT_BY_ID_SUCCESS:
      return { ...state, loading: false, product: action.payload };
    case types.CREATE_PRODUCT_SUCCESS:
      return { ...state, loading: false, products: [...state.products, action.payload] };
    case types.UPDATE_PRODUCT_SUCCESS:
      return {
        ...state,
        loading: false,
        products: state.products.map((p) => (p._id === action.payload._id ? action.payload : p)),
        product: state.product && state.product._id === action.payload._id ? action.payload : state.product,
      };
    case types.DELETE_PRODUCT_SUCCESS:
      return {
        ...state,
        loading: false,
        products: state.products.filter((p) => p._id !== action.payload),
        product: state.product && state.product._id === action.payload ? null : state.product,
      };
    case types.FETCH_PRODUCTS_FAILURE:
    case types.FETCH_PRODUCT_STATS_FAILURE:
    case types.FETCH_PRODUCT_BY_ID_FAILURE:
    case types.CREATE_PRODUCT_FAILURE:
    case types.UPDATE_PRODUCT_FAILURE:
    case types.DELETE_PRODUCT_FAILURE:
      return { ...state, loading: false, error: action.payload };
    default:
      return state;
  }
}

export default productReducer;
